export const DEFAULT_TIMEOUT = 120000;
